import jwtDecode from 'jwt-decode';

function redirectToMainPage(next) {
  // You can display a notification here if needed
  return next({ path: '/' });
}

/**
 * Middleware to check if user has the correct right to access a certain page.
 * Checks are performed based on route meta fields `meta: { requiresAuth: true }`.
 * @param {object} router Vue router instance
 */
export default function authMiddleware(router) {
  router.beforeEach((to, from, next) => {
    if (to && to.path && to.path.startsWith('/mgmt')) {
      if (to.path === '/mgmt/login') {
        return next();
      }

      let token = localStorage.getItem('mgmtAuthToken');
      if (!token) {
        return next({ path: '/mgmt/login', query: { redirect: to.fullPath } });
      }

      try {
        let decodedToken = jwtDecode(token);
        if (decodedToken && decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
          localStorage.removeItem('mgmtAuthToken');
          return next({ path: '/mgmt/login', query: { redirect: to.fullPath } });
        }
        return next();
      } catch (err) {
        localStorage.removeItem('mgmtAuthToken');
        return next({ path: '/mgmt/login', query: { redirect: to.fullPath } });
      }
    }

    if (to && to.meta) {
      // check for the routes that have `requiresAuth: true`
      let requiresAuth = to.meta.requiresAuth;
      if (!requiresAuth) {
        return next();
      }
      let token = localStorage.getItem('authToken');
      if (!token) {
        router.push("/auth/login/" + btoa(window.location.href));
      }

      try {
        let decodedToken = jwtDecode(token);
        window.myData = decodedToken;
        return next();
      } catch (err) {
        router.push("/auth/login/" + btoa(window.location.href));
      }
    } else return next();
  })
}